<template>
  <div class="w-full bg-EXPONDO-grey-5">
    <div
      class="flex flex-wrap flex-col lg:flex-row justify-between items-center gap-2.5
        max-w-screen-2xl mx-auto p-4 lg:px-10"
    >
      <DisclaimerLogos class="lg:order-2" />
      <ExpondoCopyright class="text-EXPONDO-primary" />
    </div>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'Disclaimers',

});

</script>
